
export const D_NUMBER_PHONE = 'numberPhone';
export const MOBILE_MEDIAQUERY = 'screen and (max-width: 599px)';
export const TABLET_MEDIAQUERY = 'screen and (min-width: 600px) and (max-width: 959px)';
export const MONITOR_MEDIAQUERY = 'screen and (min-width: 960px)';
export const D_REMINDER_CODE = 'remindercode';
export const D_NUMBER = 'number';
export const D_NUMBER_AND_TEXT = 'numberAndText';
export const D_NUMBER_AND_TEXT_NON_SPACE = 'numberAndTextNonSpace';
export const D_NUMBER_AND_TEXT_UPPERCASE = 'numberAndTextuppercase';
export const D_TEXT = 'text';
export const D_EMAIL = 'email';
export const D_ACCOUNT_NAME = 'accountName';
export const D_ACCOUNT_NAME_NONE_UPPERCASE = 'accountNameNonUppercase';
export const D_ACCOUNT_MNEMONIC = 'accountMnemonic';
export const D_ADDRESS = 'textAddress';
export const D_MST = 'textTaxCode';
export const D_WEBSITE = 'textWebsite';
export const D_FREE = 'textFree';

// KHDN ----
export const D_EMAIL_FULL = 'emailFull';
export const D_PHONE_EMB_SME = 'phoneEMBSME';
export const D_NUMBER_AND_TEXT_SME = 'numberTextSme';
export const D_NUMBER_AND_TEXT_SME_CORP = 'numberTextSmeCorp';

// ---------
export const D_CURRENCY = 'currency';

export const STATUS_KPI = [
  { key: true, value: 'COMMON.ACTIVE', class: 'wf-status-inprocess' },
  { key: false, value: 'COMMON.DELETED', class: 'wf-status-reject' },
];

export const STATUS_DFORM = [
  { key: 'UNLOCK', value: 'COMMON.UNLOCK', class: 'wf-status-inprocess' },
  { key: 'LOCK', value: 'COMMON.LOCK', class: 'wf-status-reject' },
];
